import * as React from 'react';
import { Span } from '../typography';
import styled from 'styled-components';
import { color, space, themeGet } from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { Transition, animated } from 'react-spring/renderprops.cjs';
import { withRouter, RouteComponentProps } from 'react-router';
import { theme } from '../theme';

type MenuItem = { title: string; onClick?: () => void; p?: number };

type Props = RouteComponentProps &
  StyledSystemProps & {
    menuItems: Array<MenuItem>;
    menuOpen: boolean;
    onClose: () => void;
  };

const Wrapper = styled(animated.div)<StyledSystemProps>`
  ${color};
  ${space};
  top: 90px;
  right: 20px;
  position: relative;
  border-radius: 4px;
  position: absolute;
  box-shadow: 0 0px 4px -1px ${themeGet('colors.shadow', '#eee')};
  z-index: ${theme.zIndex[12]};
`;

const MenuItem = styled.div<MenuItem>`
  ${color};
  ${space};
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    cursor: pointer;
  }
`;

class DropdownMenu extends React.Component<Props> {
  render() {
    const { menuItems, menuOpen } = this.props;
    return (
      <Transition
        items={menuOpen}
        native={true}
        config={{ tension: 200, friction: 30 }}
        from={{
          opacity: 0,
          transform: 'translateY(-20px)',
        }}
        enter={{
          opacity: 1,
          transform: 'translateY(0)',
        }}
        leave={{
          opacity: 0,
          transform: 'translateY(-20px)',
          pointerEvents: 'none',
        }}
      >
        {(open: boolean) =>
          open &&
          ((styleProps: any) => (
            <Wrapper style={styleProps} bg="white">
              {menuItems.map((item: MenuItem, i: number) => {
                const { title, onClick } = item;
                return (
                  <MenuItem p={3} key={i} onClick={onClick} title={title}>
                    <Span color="coal" pointer={true}>
                      {title}
                    </Span>
                  </MenuItem>
                );
              })}
            </Wrapper>
          ))
        }
      </Transition>
    );
  }
}

export default withRouter(DropdownMenu);



// WEBPACK FOOTER //
// ./src/components/DropdownMenu.tsx